import React, { Component } from "react";
import { connect } from "react-redux";
import axios from '../../../axios/Customer'
import classes from './SignFrom.css';
import global from "../../../global.css";
import ValidationCenter from "../../../ValidationCenter/ValidationCenter";
import { signRequest, alertMessenger, RequestForRegion } from "../../../store/action/index";


class SignFrom extends Component {

    state = {
        Spiner: false,
        AgencyName: {
            value: "",
            validation: false,
            touch: false,
            message: null
        },
        AccountName: {
            value: "",
            validation: false,
            touch: false,
            message: null
        },
        Password: {
            value: "",
            validation: false,
            touch: false,
            message: null
        },
        repeatPassword: {
            value: "",
            validation: false,
            touch: false,
            message: null
        },
        Ostan: {
            value: "",
            validation: false,
            touch: false,
            message: null
        },
        Shahr: {
            value: "",
            validation: false,
            touch: true,
            message: null
        },
        Telephone: {
            value: "",
            validation: false,
            touch: false,
            message: null
        },
        Fax: {
            value: "",
            validation: false,
            touch: false,
            message: null
        },
        Address: {
            value: "",
            validation: false,
            touch: false,
            message: null
        },
        Email: {
            value: "",
            validation: false,
            touch: false,
            message: null
        },
        CEOName: {
            value: "",
            validation: false,
            touch: false,
            message: null
        },
        CEONumber: {
            value: "",
            validation: false,
            touch: false,
            message: null
        },
        HeadName: {
            value: "",
            validation: false,
            touch: false,
            message: null
        },
        HeadNUumber: {
            value: "",
            validation: false,
            touch: false,
            message: null
        },
        exterainfo: {
            value: "",
            validation: true,
            touch: false,
        },
        File: {
            value: 0,
            validation: false,
            touch: true,
            message: null,
        },
        showUPloadLoader: false,
    }

    InputHandler = (event, key) => {
        event.persist()
        if (key === "Ostan") {
            this.props.RequestForRegion(3, event.target.value)
            this.setState({
                Shahr: {
                    value: "",
                    validation: false,
                    touch: false,
                    message: null
                }
            })
        }
        this.setState(prevState => {
            return {
                [key]: {
                    ...prevState[key],
                    value: event.target.value,
                    touch: true,
                    message: null
                }
            }
        })
    }

    Validation = (props) => {
        let PayBackValid = ValidationCenter(props);
        if (!PayBackValid.valid) {
            if (PayBackValid.Message) {
                this.setState(prevState => {
                    return {
                        [props.FieldName]: {
                            ...prevState[props.FieldName],
                            validation: false,
                            message: PayBackValid.Message
                        }
                    }
                })
            }
        } else {
            this.setState(prevState => {
                return {
                    [props.FieldName]: {
                        ...prevState[props.FieldName],
                        validation: true
                    }
                }
            })
        }
    }

    EqualPass = () => {
        if (this.state.Password.value !== this.state.repeatPassword.value) {
            this.setState(prevState => {
                return {
                    repeatPassword: {
                        ...prevState.repeatPassword,
                        validation: false,
                        message: "کلمه عبور یکسان نیست"
                    }
                }
            })
        }
    }

    SelectValidation = (FieldName) => {
        if (this.state[FieldName].value === "" ||
            this.state[FieldName].value === "0"
        ) {
            this.setState(prevState => {
                return {
                    [FieldName]: {
                        ...prevState[FieldName],
                        validation: false,
                        message: "مقدار انتخابی اشتباه است"
                    }
                }
            })
        } else {
            this.setState(prevState => {
                return {
                    [FieldName]: {
                        ...prevState[FieldName],
                        validation: true,
                    }
                }
            })
        }
    }

    componentDidMount = () => {
        this.props.RequestForRegion(2, 1)
    }

    uploadAction = () => {
        this.setState(prevState => {
            return {
                showUPloadLoader: true,
                File: {
                    ...prevState.File,
                    value: "",
                    touch: true,
                    validation: false,
                    message: "",
                }
            }
        }, () => {
            let data = new FormData();
            let imagedata = document.querySelector('input[type="file"]').files[0];
            data.append("data", imagedata);
            if (imagedata && imagedata.size > 500000) {
                this.setState(prevState => {
                    return {
                        showUPloadLoader: false,
                        File: {
                            ...prevState.File,
                            value: "",
                            touch: true,
                            validation: false,
                            message: "حجم فایل بیشتر از حد مجاز"
                        }
                    }
                })
                return
            }

            axios({
                method: 'post',
                url: '/Attachment',
                data: data
            })
                .then(response => {
                    this.setState(prevState => {
                        return {
                            showUPloadLoader: false,
                            File: {
                                ...prevState.File,
                                value: response.data.Result.Id,
                                touch: true,
                                validation: true,
                                message: "",
                            }
                        }
                    })
                    this.props.alertMessenger("عملیات با موفقیت انجام شد.");
                }).catch(error => {
                    this.props.alertMessenger(error.response.data.Message);
                    this.setState(prevState => {
                        return {
                            showUPloadLoader: false,
                            File: {
                                ...prevState.File,
                                value: "",
                                touch: true,
                                validation: false,
                                message: error.response.data.Message
                            }
                        }
                    })
                })
                .catch(() => {
                    this.setState(prevState => {
                        return {
                            showUPloadLoader: false,
                            File: {
                                ...prevState.File,
                                value: "",
                                touch: true,
                                validation: false,
                                message: "خطا در ارتباط با شبکه..."
                            }
                        }
                    })
                    this.props.alertMessenger("خطا در ارتباط با شبکه")
                })
        })
    }

    CheckSignLaw = () => {
        if (
            this.state.AgencyName.validation
            && this.state.AccountName.validation
            && this.state.Password.validation
            && this.state.Ostan.validation
            && this.state.Shahr.validation
            && this.state.Telephone.validation
            && this.state.Fax.validation
            && this.state.Address.validation
            && this.state.Email.validation
            && this.state.CEOName.validation
            && this.state.CEONumber.validation
            && this.state.HeadName.validation
            && this.state.HeadNUumber.validation
            && this.state.exterainfo.validation
            && this.state.File.validation
        ) {
            let value = {
                "AgencyName": this.state.AgencyName.value,
                "AttachmentId": this.state.File.value,
                "CityId": this.state.Shahr.value,
                "Phone": this.state.Telephone.value,
                "AgencyFax": this.state.Fax.value,
                "AgencyAddress": this.state.Address.value,
                "AgencyEmail": this.state.Email.value,
                "ManagerFullName": this.state.CEOName.value,
                "ManagerMobile": this.state.CEONumber.value,
                "RepresentativeFullName": this.state.HeadName.value,
                "RepresentativeMobile": this.state.HeadNUumber.value,
                "UserName": this.state.AccountName.value,
                "Password": this.state.Password.value,
                "Description": this.state.exterainfo.value,
            }
            this.props.signRequest(value)
            this.setState({
                Spiner: true
            })
        } else {
            this.props.alertMessenger("ورودی های خود را مجددا بررسی نمایید...")
        }
    }

    componentWillReceiveProps = props => {
        if (props.signResult) {
            this.EraseFrom();
            this.setState({
                Spiner: false
            })
        } else {
            this.setState({
                Spiner: false
            })
        }
    }

    EraseFrom = () => {
        this.setState({
            Spiner: false,
            AgencyName: {
                value: "",
                validation: false,
                touch: false,
                message: null
            },
            AccountName: {
                value: "",
                validation: false,
                touch: false,
                message: null
            },
            Password: {
                value: "",
                validation: false,
                touch: false,
                message: null
            },
            repeatPassword: {
                value: "",
                validation: false,
                touch: false,
                message: null
            },
            Ostan: {
                value: "",
                validation: false,
                touch: false,
                message: null
            },
            Shahr: {
                value: "",
                validation: false,
                touch: true,
                message: null
            },
            Telephone: {
                value: "",
                validation: false,
                touch: false,
                message: null
            },
            Fax: {
                value: "",
                validation: false,
                touch: false,
                message: null
            },
            Address: {
                value: "",
                validation: false,
                touch: false,
                message: null
            },
            Email: {
                value: "",
                validation: false,
                touch: false,
                message: null
            },
            CEOName: {
                value: "",
                validation: false,
                touch: false,
                message: null
            },
            CEONumber: {
                value: "",
                validation: false,
                touch: false,
                message: null
            },
            HeadName: {
                value: "",
                validation: false,
                touch: false,
                message: null
            },
            HeadNUumber: {
                value: "",
                validation: false,
                touch: false,
                message: null
            },
            exterainfo: {
                value: "",
                validation: true,
                touch: false,
            },
            File: {
                value: 0,
                validation: false,
                touch: true,
                message: null,
            },
            showUPloadLoader: false,
        })
    }

    render() {
        return (
            <div className={classes.FormFather}>
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <input
                        type="text"
                        onChange={(e) => this.InputHandler(e, "AgencyName")}
                        maxLength={50}
                        className={this.state.AgencyName.message ? global.ErrorField : null}
                        value={this.state.AgencyName.value}
                        onBlur={() => this.Validation(
                            {
                                string: {
                                    type: 'FA',
                                    minlength: 3,
                                    maxLength: 50,
                                    value: this.state.AgencyName.value.trim(),
                                },
                                FieldName: 'AgencyName'
                            }
                        )} />
                    {
                        this.state.AgencyName.message
                            ? <span className={global.Error}>{this.state.AgencyName.message}</span>
                            : null
                    }
                    <label className={[this.state.AgencyName.touch ? global.LabelMove : null,
                    this.state.AgencyName.message ? global.ErrorLabel : null].join(" ")}>نام آژانس</label>
                </div>
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <input
                        type="text"
                        onChange={(e) => this.InputHandler(e, "AccountName")}
                        maxLength={50}
                        className={this.state.AccountName.message ? global.ErrorField : null}
                        value={this.state.AccountName.value}
                        onBlur={() => this.Validation(
                            {
                                string: {
                                    type: 'NE',
                                    minlength: 3,
                                    maxLength: 50,
                                    value: this.state.AccountName.value.trim(),
                                },
                                FieldName: 'AccountName'
                            }
                        )} />
                    {
                        this.state.AccountName.message
                            ? <span className={global.Error}>{this.state.AccountName.message}</span>
                            : null
                    }
                    <label className={[this.state.AccountName.touch ? global.LabelMove : null,
                    this.state.AccountName.message ? global.ErrorLabel : null].join(" ")}>نام کاربری</label>
                </div>

                {/* Password */}
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <input
                        type="password"
                        onChange={(e) => this.InputHandler(e, "Password")}
                        maxLength={18}
                        className={this.state.Password.message ? global.ErrorField : null}
                        value={this.state.Password.value}
                        onBlur={() => this.Validation(
                            {
                                string: {
                                    type: 'PASS',
                                    minlength: 9,
                                    maxLength: 18,
                                    value: this.state.Password.value.trim(),
                                },
                                FieldName: 'Password'
                            }
                        )} />
                    {
                        this.state.Password.message
                            ? <span className={global.Error}>{this.state.Password.message}</span>
                            : null
                    }
                    <label className={[this.state.Password.touch ? global.LabelMove : null,
                    this.state.Password.message ? global.ErrorLabel : null].join(" ")}>کلمه عبور</label>
                </div>

                {/* repeatPassword */}
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <input
                        type="password"
                        onChange={(e) => this.InputHandler(e, "repeatPassword")}
                        maxLength={18}
                        className={this.state.repeatPassword.message ? global.ErrorField : null}
                        value={this.state.repeatPassword.value}
                        onBlur={() => this.EqualPass(
                            {
                                string: {
                                    type: 'PASS',
                                    minlength: 9,
                                    maxLength: 18,
                                    value: this.state.repeatPassword.value.trim(),
                                },
                                FieldName: 'repeatPassword'
                            }
                        )} />
                    {
                        this.state.repeatPassword.message
                            ? <span className={global.Error}>{this.state.repeatPassword.message}</span>
                            : null
                    }
                    <label className={[this.state.repeatPassword.touch ? global.LabelMove : null,
                    this.state.repeatPassword.message ? global.ErrorLabel : null].join(" ")}>تکرار کلمه عبور</label>
                </div>


                {/* Ostan */}
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <select
                        value={this.state.Ostan.value}
                        onBlur={() => this.SelectValidation("Ostan")}
                        className={this.state.Ostan.message ? global.ErrorField : null}
                        onChange={(e) => this.InputHandler(e, "Ostan")}>
                        {
                            this.props.ostanList
                                ?
                                this.props.ostanList.map(item => {
                                    return <option key={item.Id} value={item.Id}>{item.Name}</option>
                                })
                                : <option value={'0'}>درحال دریافت اطلاعات...</option>
                        }
                    </select>
                    {
                        this.state.Ostan.message
                            ? <span className={global.Error}>{this.state.Ostan.message}</span>
                            : null
                    }
                    <label className={[this.state.Ostan.touch ? global.LabelMove : null,
                    this.state.Ostan.message ? global.ErrorLabel : null].join(" ")}>استان</label>
                </div>



                {/* Shahr */}
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <select
                        value={this.state.Shahr.value}
                        onBlur={() => this.SelectValidation("Shahr")}
                        className={this.state.Shahr.message ? global.ErrorField : null}
                        onChange={(e) => this.InputHandler(e, "Shahr")}>
                        {
                            this.props.shahrList
                                ?
                                this.props.shahrList.map(item => {
                                    return <option key={item.Id} value={item.Id}>{item.Name}</option>
                                })
                                : <option value={'0'}>ابتدا نام استان را انتخاب کنید</option>
                        }
                    </select>
                    {
                        this.state.Shahr.message
                            ? <span className={global.Error}>{this.state.Shahr.message}</span>
                            : null
                    }
                    <label className={[this.state.Shahr.touch ? global.LabelMove : null,
                    this.state.Shahr.message ? global.ErrorLabel : null].join(" ")}>شهر</label>
                </div>


                {/* Telephone */}
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <input
                        type="text"
                        onChange={(e) => this.InputHandler(e, "Telephone")}
                        maxLength={11}
                        className={this.state.Telephone.message ? global.ErrorField : null}
                        value={this.state.Telephone.value}
                        onBlur={() => this.Validation(
                            {
                                number: {
                                    type: 'NUM',
                                    minlength: 11,
                                    maxLength: 11,
                                    value: this.state.Telephone.value.trim(),
                                },
                                FieldName: 'Telephone'
                            }
                        )} />
                    {
                        this.state.Telephone.message
                            ? <span className={global.Error}>{this.state.Telephone.message}</span>
                            : null
                    }
                    <label className={[this.state.Telephone.touch ? global.LabelMove : null,
                    this.state.Telephone.message ? global.ErrorLabel : null].join(" ")}>تلفن</label>
                </div>


                {/* Fax */}
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <input
                        type="text"
                        onChange={(e) => this.InputHandler(e, "Fax")}
                        maxLength={11}
                        className={this.state.Fax.message ? global.ErrorField : null}
                        value={this.state.Fax.value}
                        onBlur={() => this.Validation(
                            {
                                number: {
                                    type: 'NUM',
                                    minlength: 11,
                                    maxLength: 11,
                                    value: this.state.Fax.value.trim(),
                                },
                                FieldName: 'Fax'
                            }
                        )} />
                    {
                        this.state.Fax.message
                            ? <span className={global.Error}>{this.state.Fax.message}</span>
                            : null
                    }
                    <label className={[this.state.Fax.touch ? global.LabelMove : null,
                    this.state.Fax.message ? global.ErrorLabel : null].join(" ")}>فکس</label>
                </div>


                {/* Address */}
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <input
                        type="text"
                        onChange={(e) => this.InputHandler(e, "Address")}
                        maxLength={150}
                        className={this.state.Address.message ? global.ErrorField : null}
                        value={this.state.Address.value}
                        onBlur={() => this.Validation(
                            {
                                string: {
                                    type: 'FN',
                                    minlength: 3,
                                    maxLength: 150,
                                    value: this.state.Address.value.trim(),
                                },
                                FieldName: 'Address'
                            }
                        )} />
                    {
                        this.state.Address.message
                            ? <span className={global.Error}>{this.state.Address.message}</span>
                            : null
                    }
                    <label className={[this.state.Address.touch ? global.LabelMove : null,
                    this.state.Address.message ? global.ErrorLabel : null].join(" ")}>آدرس</label>
                </div>


                {/* Email */}
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <input
                        type="text"
                        onChange={(e) => this.InputHandler(e, "Email")}
                        maxLength={80}
                        className={this.state.Email.message ? global.ErrorField : null}
                        value={this.state.Email.value}
                        onBlur={() => this.Validation(
                            {
                                email: {
                                    type: 'NE',
                                    minlength: 5,
                                    maxLength: 80,
                                    value: this.state.Email.value.trim(),
                                },
                                FieldName: 'Email'
                            }
                        )} />
                    {
                        this.state.Email.message
                            ? <span className={global.Error}>{this.state.Email.message}</span>
                            : null
                    }
                    <label className={[this.state.Email.touch ? global.LabelMove : null,
                    this.state.Email.message ? global.ErrorLabel : null].join(" ")}>ایمیل</label>
                </div>



                {/* CEOName */}
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <input
                        type="text"
                        onChange={(e) => this.InputHandler(e, "CEOName")}
                        maxLength={50}
                        className={this.state.CEOName.message ? global.ErrorField : null}
                        value={this.state.CEOName.value}
                        onBlur={() => this.Validation(
                            {
                                string: {
                                    type: 'FA',
                                    minlength: 3,
                                    maxLength: 50,
                                    value: this.state.CEOName.value.trim(),
                                },
                                FieldName: 'CEOName'
                            }
                        )} />
                    {
                        this.state.CEOName.message
                            ? <span className={global.Error}>{this.state.CEOName.message}</span>
                            : null
                    }
                    <label className={[this.state.CEOName.touch ? global.LabelMove : null,
                    this.state.CEOName.message ? global.ErrorLabel : null].join(" ")}>نام و نام خانوادگی مدیر آژانس</label>
                </div>


                {/* CEONumber */}
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <input
                        type="text"
                        onChange={(e) => this.InputHandler(e, "CEONumber")}
                        maxLength={11}
                        className={this.state.CEONumber.message ? global.ErrorField : null}
                        value={this.state.CEONumber.value}
                        onBlur={() => this.Validation(
                            {
                                number: {
                                    type: 'NUM',
                                    minlength: 11,
                                    maxLength: 11,
                                    value: this.state.CEONumber.value.trim(),
                                },
                                FieldName: 'CEONumber'
                            }
                        )} />
                    {
                        this.state.CEONumber.message
                            ? <span className={global.Error}>{this.state.CEONumber.message}</span>
                            : null
                    }
                    <label className={[this.state.CEONumber.touch ? global.LabelMove : null,
                    this.state.CEONumber.message ? global.ErrorLabel : null].join(" ")}>تلفن همراه مدیر آژانس</label>
                </div>


                {/* HeadName */}
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <input
                        type="text"
                        onChange={(e) => this.InputHandler(e, "HeadName")}
                        maxLength={50}
                        className={this.state.HeadName.message ? global.ErrorField : null}
                        value={this.state.HeadName.value}
                        onBlur={() => this.Validation(
                            {
                                string: {
                                    type: 'FA',
                                    minlength: 3,
                                    maxLength: 50,
                                    value: this.state.HeadName.value.trim(),
                                },
                                FieldName: 'HeadName'
                            }
                        )} />
                    {
                        this.state.HeadName.message
                            ? <span className={global.Error}>{this.state.HeadName.message}</span>
                            : null
                    }
                    <label className={[this.state.HeadName.touch ? global.LabelMove : null,
                    this.state.HeadName.message ? global.ErrorLabel : null].join(" ")}>نام و نام خانوادگی نماینده </label>
                </div>



                {/* HeadNUumber */}
                <div className={[global.inputFather, classes.DifrentFather].join(" ")}>
                    <input
                        type="text"
                        onChange={(e) => this.InputHandler(e, "HeadNUumber")}
                        maxLength={11}
                        className={this.state.HeadNUumber.message ? global.ErrorField : null}
                        value={this.state.HeadNUumber.value}
                        onBlur={() => this.Validation(
                            {
                                number: {
                                    type: 'NUM',
                                    minlength: 11,
                                    maxLength: 11,
                                    value: this.state.HeadNUumber.value.trim(),
                                },
                                FieldName: 'HeadNUumber'
                            }
                        )} />
                    {
                        this.state.HeadNUumber.message
                            ? <span className={global.Error}>{this.state.HeadNUumber.message}</span>
                            : null
                    }
                    <label className={[this.state.HeadNUumber.touch ? global.LabelMove : null,
                    this.state.HeadNUumber.message ? global.ErrorLabel : null].join(" ")}>تلفن همراه نماینده </label>
                </div>



                {/* Extra Info */}
                <div className={[global.inputFather, classes.description].join(" ")}>
                    <textarea
                        rows="6"
                        onChange={(e) => this.InputHandler(e, "exterainfo")}
                        maxLength={1000}
                        value={this.state.exterainfo.value}
                    />
                    <label className={this.state.exterainfo.touch ? global.LabelMove : null}>توضیحات</label>
                </div>

                <div className={[global.inputFather, classes.FileUpload].join(" ")}>
                    <input
                        accept= ".png, .jpg, .jpeg, .pdf"
                        type="file"
                        onChange={this.uploadAction}
                        maxLength={11}
                        className={this.state.File.message ? global.ErrorField : null}
                    />
                    {this.state.showUPloadLoader
                        ? <i className={global.Loader}></i>
                        : null
                    }
                    {
                        this.state.File.message
                            ? <span className={global.Error}>{this.state.File.message}</span>
                            : null
                    }
                    <label size="60" className={[this.state.File.touch ? global.LabelMove : null,
                    this.state.File.message ? global.ErrorLabel : null].join(" ")}>تصویر جواز</label>
                    <p className={classes.Size}>حداکثر حجم فایل : 500 کیلوبایت</p>
                </div>


                <button
                    style={{
                        display: "block",
                        marginTop: "30px"
                    }}
                    onClick={this.CheckSignLaw}
                    className={this.props.signResult && this.state.Spiner ? global.Load : null}
                    disabled={this.props.signResult && this.state.Spiner}>
                    <span className={this.props.signResult && this.state.Spiner ? global.Loader : null}></span>
                    ثبت</button>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ostanList: state.SIGN.ostanList,
        shahrList: state.SIGN.shahrList,
        signResult: state.SIGN.signResult
    }
}

const mapDispatchToProps = dispatch => {
    return {
        RequestForRegion: (Type, parent) => dispatch(RequestForRegion(Type, parent)),
        alertMessenger: (SMS) => dispatch(alertMessenger(SMS)),
        signRequest: (item) => dispatch(signRequest(item))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignFrom)